import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { refreshObligations } from './store/actions';
import { isRefreshingObligationsSelector } from './store/selectors';

import { RefreshEntityNavigationButton } from '../../shared/refreshEntityNavigationButton.component';
import { AuthorizeUserTree, permissions, permissionTypes } from '../../shared/authorization';

export const PureRefreshObligationsMenuButton = ({
  refreshObligations,
  isRefreshingObligations,
}) => (
  <RefreshEntityNavigationButton
    refreshEntity={refreshObligations}
    isRefreshingEntity={isRefreshingObligations}
    buttonLabel="Refresh Obligations"
  />
);

PureRefreshObligationsMenuButton.propTypes = {
  refreshObligations: PropTypes.func.isRequired,
  isRefreshingObligations: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isRefreshingObligations: isRefreshingObligationsSelector(state),
});

export const RefreshObligationsMenuButton = connect(mapStateToProps, {
  refreshObligations,
})(PureRefreshObligationsMenuButton);

const additionalItems = [
  <AuthorizeUserTree
    withPermissions={[{
      permissionType: permissionTypes.MODIFY,
      permissionPath: permissions.COMPANY_CODES,
    }]}
    key="refreshObligationsMenuButton"
  >
    <RefreshObligationsMenuButton />
  </AuthorizeUserTree>,
];

export default additionalItems;
